import request from '@/utils/request'
import ENDPOINT from '@/config/endpoint'

export function recordUtilsCount(data) {
  return request({
    url: ENDPOINT.RECORD_UTILS_COUNT,
    method: 'post',
    data
  })
}
